import { colors } from '@hover/blueprint/foundation';
import { transparentize } from 'polished';
import React, { useState } from 'react';
import { Container, Heading, Body, Stack } from '@hover/blueprint';
import { navigate } from 'gatsby';
import { DownloadAppModal } from '../../common';
import ArrowButton from '../../ui/ArrowButton';
import { CHAT_WITH_A_REP_LINK } from '../../../constants';

const ReadyToSeeContent: React.FC = () => {
  const [isOpen, setOpen] = useState<boolean>(false);

  const toggleModal = () => setOpen(!isOpen);
  const navigateTo = () => navigate(CHAT_WITH_A_REP_LINK);

  return (
    <Container maxW="100%">
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Heading
        color="brandNavy.500"
        maxW={{ base: '100%', tablet: '350px', desktop: '400px' }}
        size={{ base: 500, tablet: 600, desktop: 700 }}
        marginBottom={{ base: 500, desktop: 500 }}
        textAlign={{ base: 'center', tablet: 'left' }}
      >
        Ready to see the possibilities?
      </Heading>
      <Body
        color="brandNavy.500"
        maxW={{ base: '100%', tablet: '350px', desktop: '390px' }}
        size={{ base: 500, tablet: 600 }}
        textAlign={{ base: 'center', tablet: 'left' }}
        marginBottom={700}
      >
        Whether you’re a small business, a national team, or somewhere in
        between, we got you.
      </Body>
      <Stack
        spacing={500}
        direction={{ base: 'column', tablet: 'row' }}
        alignItems="center"
        justifycontent="center"
      >
        <ArrowButton
          colorScheme="brandNavy"
          variant="outline"
          onClick={toggleModal}
          _hover={{ background: transparentize(0.9, colors.brandNavy[700]) }}
          _active={{ background: transparentize(0.8, colors.brandNavy[700]) }}
        >
          Try it free
        </ArrowButton>
        <ArrowButton
          variant="minimal"
          colorScheme="brandNavy"
          // TODO(buttons): remove when we remove padding in Blueprint
          sx={{ div: { pl: 100, pr: 50 } }}
          onClick={navigateTo}
        >
          Chat with a rep
        </ArrowButton>
      </Stack>
    </Container>
  );
};

export default ReadyToSeeContent;
